var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcMfa1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.16,
    y1: 0.064,
    x2: 0.86,
    y2: 0.931,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#35a3da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#055d8a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3124",
    "data-name": "Rectangle 3124",
    width: 64,
    height: 64,
    transform: "translate(1872.527 1430.042)",
    fill: "url(#linear-gradient)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_mfa",
    transform: "translate(-1872.527 -1430.042)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_271",
    "data-name": "Union 271",
    d: "M6.346,64A6.561,6.561,0,0,1,0,57.259V6.736A6.555,6.555,0,0,1,6.346,0H31.734a6.558,6.558,0,0,1,6.349,6.736V57.259A6.563,6.563,0,0,1,31.734,64Zm9.93-5.822a2.473,2.473,0,1,0,2.467-2.617A2.549,2.549,0,0,0,16.276,58.18ZM5.013,52.492H33.068V5.322H5.013Zm13.544-11.21A28.9,28.9,0,0,1,13.9,37.927c-2.219-2.023-3.345-3.984-3.345-5.831V23.518c0-.419,8.391-2.8,8.475-2.823.087.016,8.482,2.392,8.482,2.823V32.1c0,1.852-1.125,3.818-3.333,5.846a26.017,26.017,0,0,1-4.68,3.34.8.8,0,0,1-.464.145A.832.832,0,0,1,18.557,41.283ZM16.766,27.839a.884.884,0,0,0,.885.88h.5v1.8A3.194,3.194,0,1,0,21.3,35.846a3.178,3.178,0,0,0,0-4.516,3.24,3.24,0,0,0-1.383-.812V24.487a.883.883,0,0,0-1.766,0v.2h-.5a.881.881,0,1,0,0,1.762h.5v.516h-.5A.88.88,0,0,0,16.766,27.839Zm.818,5.75a1.447,1.447,0,1,1,1.453,1.44A1.445,1.445,0,0,1,17.583,33.589Z",
    transform: "translate(1885.485 1430.041)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMfa1);
export default __webpack_public_path__ + "static/media/ic_mfa_1.f87ea8e94216c568203e7936d5f5a909.svg";
export { ForwardRef as ReactComponent };